import Cookies from "js-cookie";
import { useUserStore } from "../store/user.store";
// import { history } from "..";
import { useCommunitiesStore } from "../store/communities.store";
import {
  axiosMobileAuthInstance,
  axiosMobileInstance,
} from "../config/axios-config-mobile";
// import { showAlertModal } from "../jsx/pages/trybz_dashboard/_components/customModals/AlertModal";

var MobileGatewayService = {
  refreshToken: async function (failedRequest) {
    const refresh_token = Cookies.get("refresh_token");
    if (refresh_token !== undefined)
      return axiosMobileInstance
        .post("/auth/refresh", { refreshToken: refresh_token })
        .then((res) => {
          Cookies.set("access_token", res.data.accessToken);
          Cookies.set("refresh_token", res.data.refreshToken);
          Cookies.set("TrybzExpToken", res.data.expiresAt);

          failedRequest.response.config.headers["Authorization"] =
            "Bearer " + res.data;
          return Promise.resolve();
        });
  },

  login: async function (email, password, type = "customer") {
    return await axiosMobileInstance
      .post("/auth/login", {
        email: email,
        password: password,
        type: type,
      })
      .then(async (res) => {
        Cookies.set("access_token", res.data.accessToken);
        Cookies.set("refresh_token", res.data.refreshToken);
        useUserStore.setState({
          isLoggedIn: true,
          hasSetpassword: res.data.hasSetPassword,
          hasLoggedInBefore: res.data.hasLoggedInBefore,
        });
        Cookies.set("TrybzExpToken", res.data.expiresAt);

        return res.data;
      });
  },

  verifyPassword: async function (password) {
    return await axiosMobileAuthInstance
      .post("/auth/password/verify", { password: password })
      .then(async (res) => {
        return res.data;
      });
  },

  logout: function () {
    Cookies.remove("access_token");
    Cookies.remove("refresh_token");
    Cookies.remove("TrybzExpToken");
    window.location = "/login";
    useUserStore.setState({
      hasSetpassword: false,
      isLoggedIn: false,
      user: null,
      activeRole: null,
      isImpersonating: false,
      currentPath: "",
    });
    useCommunitiesStore.setState({
      communityId: "",
      communityData: null,
    });
  },

  forgotPassword: async function (email) {
    return await axiosMobileInstance.post("/auth/password/forgot", {
      email: email,
    });
  },

  changePassword: async function (input) {
    return await axiosMobileAuthInstance.put("/auth/password", { ...input });
  },

  resetPassword: async function (input) {
    return await axiosMobileAuthInstance.post("/auth/password/reset", {
      ...input,
    });
  },

  sendOtp: async function (phoneNumber) {
    return await axiosMobileAuthInstance.post("/auth/otp/send", {
      phoneNumber: phoneNumber,
    });
  },

  verifyOtp: async function (input) {
    return await axiosMobileAuthInstance
      .post("/auth/otp/verify", { ...input })
      .then(async (res) => {
        return res.data;
      });
  },

  initiateEmailChange: async function (newEmail) {
    return await axiosMobileAuthInstance.post("/auth/email/change/initiate", {
      newEmail: newEmail,
    });
  },

  confirmEmailChange: async function (input) {
    return await axiosMobileInstance.post("/auth/email/change/confirm", {
      ...input,
    });
  },

  initiatePhoneChange: async function () {
    return await axiosMobileAuthInstance.post("/auth/phone/change/initiate");
  },

  confirmPhoneChange: async function (input) {
    return await axiosMobileInstance.post("/auth/phone/change/confirm", {
      ...input,
    });
  },

  initiatePasswordChange: async function () {
    return await axiosMobileAuthInstance.post("/auth/password/change/initiate");
  },
  getUserData: async function () {
    return await axiosMobileAuthInstance.get("/users/me").then((res) => {
      return res.data;
    });
  },

  completeUserProfile: async function (payload) {
    return await axiosMobileAuthInstance.post("/users/me/profile", {
      ...payload,
    });
  },

  // resident accept invite
  residentAcceptInvite: async function (id) {
    return await axiosMobileAuthInstance.post(`/residents/invite/${id}/accept`);
  },

  // tribe member accept invite
  tribeMemberAcceptInvite: async function (id) {
    return await axiosMobileAuthInstance.post(
      `/tribe-members/invite/${id}/accept`
    );
  },
};

export default MobileGatewayService;
